import axios from 'axios';

const realm = localStorage.getItem('realm');
const api = axios.create({
  // baseURL: 'http://192.168.15.5:5000',
  baseURL: 'https://campusconectado.idc19.com.br:5443',
});
api.defaults.withCredentials = true;
api.defaults.headers.common.realm = realm;

export default api;
